import React from 'react';
import _ from 'lodash';
import { Col, Row } from '@mlc/web-ui-toolkit';
import * as Styled from '../styled';
import { InvestmentFilterElements } from './InvestmentFilterElements';
import AdvisedPortfolioFilter from './AdvisedPortfolioFilter/AdvisedPortfolioFilter';
import InvestmentTypeFilter from './InvestmentTypeFilter/InvestmentTypeFilter';
import InvestmentOptionsFilter from './InvestmentOptionsFilter/InvestmentOptionsFilter';

interface Props {
	investmentFilters: {
		advisedPortfolioMin: string;
		advisedPortfolioMax: string;
		investmentType: string[];
		investmentOptions: string[];
		initialInvestmentOptions: FundOption[];
	};
	formikProps: any;
}

export interface FundOption {
	value: string;
	label: string;
}

const InvestmentFilters = (props: Props) => {
	const {
		advisedPortfolioMin,
		advisedPortfolioMax,
		investmentType,
		investmentOptions,
		initialInvestmentOptions,
	} = props.investmentFilters;

	return (
		<div data-id={InvestmentFilterElements.investmentFiltersId}>
			<Styled.SectionHeadingRow>
				<Col>
					<Styled.SectionHeading el="h5">Investments</Styled.SectionHeading>
				</Col>
			</Styled.SectionHeadingRow>
			<Row>
				<Col md="5" sm="12">
					<InvestmentTypeFilter investmentType={investmentType} />
				</Col>
				<Col md="5" sm="12" mdOffset="2">
					<AdvisedPortfolioFilter
						advisedPortfolioMin={advisedPortfolioMin}
						advisedPortfolioMax={advisedPortfolioMax}
						formikProps={props.formikProps}
					/>
				</Col>
			</Row>
			<Row>
				<Col sm="12" md="12" lg="6">
					<InvestmentOptionsFilter
						investmentOptions={investmentOptions}
						initialInvestmentOptions={initialInvestmentOptions}
						formikProps={props.formikProps}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default InvestmentFilters;
